import type { IPlanResponse, IPlanListResponse } from '@escloud/types';

import type { ApiClient } from './api-client';

export class PlansService {
    constructor(private api: ApiClient) {}

    getPlans(): Promise<IPlanListResponse> {
        return this.api.get<IPlanListResponse>('/plans', { skipAuth: true });
    }

    getPlan(planId: string): Promise<IPlanResponse> {
        return this.api.get<IPlanResponse>(`/plans/${planId}`, { skipAuth: true });
    }
}
